import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSubscription } from '@/lib/contexts/SubscriptionContext'
import { useAuth } from '@/lib/contexts/AuthContext'
import { finalizeAgentsCheckout } from '@/lib/api/billing'
import { SystemCardShell, SystemCardHeading, SystemCardSecondary } from '@/components/shared/layout'

const API_URL = import.meta.env.VITE_PUBLIC_API_URL
  ? `${import.meta.env.VITE_PUBLIC_API_URL}`
  : import.meta.env.VITE_PUBLIC_IS_PROD === 'TRUE'
  ? 'https://app.humblytics.com'
  : 'http://localhost:3000'

export default function AgentComplete() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { refreshSubscription } = useSubscription()
  const { token } = useAuth()
  const sessionId = searchParams.get('session_id')

  // Agents plan return from Stripe: apply the purchase now rather than waiting
  // for the webhook, then refresh so the new limit shows. Idempotent server-side.
  useEffect(() => {
    if (!sessionId || !token) return
    finalizeAgentsCheckout(token, sessionId)
      .catch(() => {
        // The checkout.session.completed webhook applies it anyway
      })
      .finally(() => refreshSubscription())
  }, [sessionId, token, refreshSubscription])

  useEffect(() => {
    // Mark the agent session complete (reads authToken cookie server-side)
    fetch(`${API_URL}/api/v1/auth/agent-mark-complete`, {
      credentials: 'include',
    }).catch(() => {
      // Non-critical — session TTL will clean up naturally
    })

    // Refresh subscription so the rest of the app reflects the new plan
    refreshSubscription()
  }, [refreshSubscription])

  return (
    <SystemCardShell>
      <SystemCardHeading success eyebrow="Payment confirmed" title="Head back to your agent">
        {sessionId
          ? 'Your Agents plan is on: 100,000 data points for the next 12 months. Your agent can carry on.'
          : 'Your agent can now add your website and finish setting everything up.'}
      </SystemCardHeading>
      <SystemCardSecondary onClick={() => navigate('/dashboard')}>Open dashboard</SystemCardSecondary>
    </SystemCardShell>
  )
}
